import React from 'react';
import { Box } from 'grommet'
import { Group, Home, Rewind, Scorecard, Schedule, Sort } from 'grommet-icons'
import MenuLink from './MenuLink'
import BioLink from './BioLink';
import { FaQuestion } from 'react-icons/fa'

class MenuContent extends React.Component {
  
  render() {
    
    var translationUp = 'translateX(-250px)'
    var translationDown = 'translateX(0px)'
    var bgcolor = "black"
    var translation = translationUp;
    if (this.props.menuVisibility) {
      translation = translationDown;
    }

    return (
      <Box
          style={{
            position: 'fixed',
            zIndex: '998',
            top: '0px',
            backgroundColor: bgcolor,
            transition: 'transform 0.5s ease, top 0.5s ease',
            transform: translation,    
            left: '0',
            width: '250px',
            paddingTop: '60px',
            paddingBottom: '10px',
            height: '100%',
            borderRight: '1px solid fade-out($white, 0.9)'
          }}
        >
          <MenuLink 
            label='Accueil'
            icon={<Home color='text' style={{paddingLeft: '17' }} />}
            to='/'
          />
          <MenuLink 
            label='Semaine Dernière'
            icon={<Scorecard color='text' style={{paddingLeft: '17' }} />}
            to='/lastweek'
          />
          <MenuLink 
            label='Depuis Janvier'
            icon={<Rewind color='text' style={{paddingLeft: '17' }} />}
            to='/year'
          />
          <MenuLink 
            label='Semaine par Semaine'
            icon={<Schedule color='text' style={{paddingLeft: '17' }} />}
            to='/allweeks'
          />
          <MenuLink 
            label='Graphiques'
            icon={<Sort color='text' style={{paddingLeft: '17' }} />}
            to='/graph'
          />
          <MenuLink 
            label='Membres'
            icon={<Group color='text' style={{paddingLeft: '17' }} />}
            to='/members2'
          />
          <BioLink 
            label='created by'
            icon={<FaQuestion color='yellow' size='0.7em' style={{paddingLeft: '22'}} />}
            to='/bio'
          />
        </Box>
    );
  }
}

export default MenuContent
